import styled from 'styled-components';

export const SavedCard = styled.div`
  .info-column {
    flex-basis: 22%;
  }
`;
